const PROPERTIES = {
	NATIVE_COMPONENTS: 'nativeComponents',
	DISABLE_SIDEBAR_ANIMATION: 'disableSidebarAnimation',
	SHOW_SPINNER_INSTEAD_OF_ACCOUNTMENU: 'showSpinnerInsteadOfAccountMenu',
	URL_SCHEME: 'urlScheme',
	BANKID_LOGIN: 'bankidLogin',
	NATIVE_REG_HEADER_ENABLED: 'nativeRegHeaderEnabled',
	NATIVE_NAV_HEADER_ENABLED: 'nativeNavHeaderEnabled',
	APP_HIDES_WEB_FOOTER_LINKS: 'appHidesWebFooterLinks',
	IS_SWISH_APP_SUPPORTED: 'isSwishAppSupported',
	MITID_V2_ENABLED: 'mitIdV2Enabled',
	APP_HIDES_PRODUCT_FILTER: 'appHidesProductFilter',
	NATIVE_PRODUCT_SWITCH_ENABLED: 'nativeProductSwitchEnabled',
	APP_HIDES_WELCOME_POPUP: `disableDEGAWelcomeScreen`,
	NATIVE_WEBSOCKET_ENABLED: 'nativeWebSocketEnabled',
	NATIVE_MENTOR_MESSAGE_ENABLED: 'nativeMentorMessageEnabled',
	NATIVE_GAMEPLAY_BLOCK_ENABLED: 'nativeGamePlayBlockEnabled',
	NATIVE_KSA_REALITY_CHECK_ENABLED: 'nativeKSARealityCheckEnabled',
	NATIVE_NOTIFICATION_ENABLED: 'nativeNotificationEnabled',
	NATIVE_BOTTOMNAVIGATION_ENABLED: 'nativeBottomNavigationEnabled'
};

const setAppProperties = appProperties => {
	if (appProperties && appProperties[0]) {
		window.appProperties = { ...appProperties[0] };
	}
};

const getAppProperty = key => {
	if (window.appProperties) {
		return window.appProperties[key];
	}

	return null;
};

const appHidesWebFooterLinks = () => {
	return false;
};

const isNativeComponentsEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_COMPONENTS);
};

const isSidebarAnimationDisabled = () => {
	return !!getAppProperty(PROPERTIES.DISABLE_SIDEBAR_ANIMATION);
};

const showSpinnerInsteadOfAccountMenu = () => {
	return !!getAppProperty(PROPERTIES.SHOW_SPINNER_INSTEAD_OF_ACCOUNTMENU);
};

const getAppUrlScheme = () => {
	return getAppProperty(PROPERTIES.URL_SCHEME);
};

const isAppBankIdSupported = () => {
	return !!getAppProperty(PROPERTIES.BANKID_LOGIN);
};

const isNativeRegHeaderEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_REG_HEADER_ENABLED);
};

const isNativeNavHeaderEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_NAV_HEADER_ENABLED);
};

const isNativeWelcomePopupEnabled = () => {
	return !!getAppProperty(PROPERTIES.APP_HIDES_WELCOME_POPUP);
};

const isSwishSupportedOnApp = () => {
	return !!getAppProperty(PROPERTIES.IS_SWISH_APP_SUPPORTED);
};

const mitidV2Enabled = () => {
	return !!getAppProperty(PROPERTIES.MITID_V2_ENABLED);
};

const nativeAppHidesProductFilter = () => {
	return !!getAppProperty(PROPERTIES.APP_HIDES_PRODUCT_FILTER);
};

const isNativeProductSwitchEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_PRODUCT_SWITCH_ENABLED);
};

const isNativeWebSocketEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_WEBSOCKET_ENABLED);
};

const isNativeMentorMessageEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_MENTOR_MESSAGE_ENABLED);
};

const isNativeGamePlayBlockEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_GAMEPLAY_BLOCK_ENABLED);
};

const isNativeKSARealityCheckEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_KSA_REALITY_CHECK_ENABLED);
};

const isNativeNotificationEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_NOTIFICATION_ENABLED);
};

const isNativeBottomNavigationEnabled = () => {
	return !!getAppProperty(PROPERTIES.NATIVE_BOTTOMNAVIGATION_ENABLED);
};

export {
	setAppProperties,
	isNativeComponentsEnabled,
	isSidebarAnimationDisabled,
	showSpinnerInsteadOfAccountMenu,
	getAppUrlScheme,
	isAppBankIdSupported,
	isNativeRegHeaderEnabled,
	isNativeNavHeaderEnabled,
	appHidesWebFooterLinks,
	isSwishSupportedOnApp,
	mitidV2Enabled,
	nativeAppHidesProductFilter,
	isNativeProductSwitchEnabled,
	isNativeWelcomePopupEnabled,
	isNativeWebSocketEnabled,
	isNativeMentorMessageEnabled,
	isNativeGamePlayBlockEnabled,
	isNativeKSARealityCheckEnabled,
	isNativeNotificationEnabled,
	isNativeBottomNavigationEnabled
};
